import script from "./IndexEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexEvent.vue?vue&type=script&setup=true&lang=js"

import "./IndexEvent.vue?vue&type=style&index=0&id=e684c5b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e684c5b2"]])

export default __exports__